// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"313":"5d5f616c48bba563","425":"2a379b4a1c66db82","436":"fe71157b734835e3","525":"d3bc6520c9556340","752":"5dae2dd8e29e2ad6","954":"d0f2bf40c98b38d6","961":"d32b0fd6ef31fa2e","974":"f6c0abd1e99647d8"}[chunkId] + ".js";
};